import 'whatwg-fetch'
import {message} from 'antd'
import {isAuthenticated} from './Session'
import appStore from '../stores/appStore'
import { runInAction } from 'mobx'

const error = {status: 0, msg: '网络错误'}
const loginError = {status: 0, msg: '登陆错误'}

export const companyId = JSON.parse(process.env.REACT_APP_COMPANY).companyId

export async function get(url, param) {
    try {
        url=judgeURL(url,param)
        const response = await fetch(url, {
            credentials: 'include',
        })
        if (response.status === 401) {
            // message.error("登陆错误")
            runInAction(()=>{
                appStore.isLogin=false
            })
            await isAuthenticated.logout()
            return loginError
        }
        const result = await response.json()
        if (response.status >= 400) {
            if (result.code) {
                message.error(result.msg)
            }
            // else {
            //     message.error("请求异常1")
            // }
            return error
        }
        return result
    } catch (err) {
        return error
    }
}

export async function post(url, param) {
    try {
        const response = await fetch(url, {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: _encodeParam(param),
        })
        if (response.status === 401) {
            // message.error("登陆错误")
            await appStore.logout()
            return loginError
        }
        const result = await response.json()
        if (response.status >= 400) {
            if (result.code) {
                message.error(result.msg)
            }
            // else {
            //     message.error("请求异常2")
            // }

            return error
        }
        return result
    } catch (err) {
        return error
    }
}

async function _json(url, json, method) {
    try {
        url=judgeURL(url,null)
        const response = await fetch(url, {
            credentials: 'include',
            method: method,
            headers: new Headers({
                'Content-Type': 'application/json',
                'x-access-token': isAuthenticated(),
            }),
            body: JSON.stringify(json),
        })
        const result = await response.json()
        if (response.status >= 400) {
            if (response.status === 401) {
                // message.error("登陆错误")
                await appStore.logout()
                return loginError
            }
            if (result.code) {
                message.error(result.msg)
            }
            // else {
            //     message.error("请求异常3")
            // }
            return error
        }
        // if (result.code) {
        //     message.success(result.msg)
        // }
        return result
    } catch (err) {
        return error
    }
}

export const json = {
    get: async function (url, param) {
        return get(url, param)
    },
    post: async function (url, json) {
        return _json(url, json, 'POST')
    },
    put: async function (url, json) {
        return _json(url, json, 'POST')
    },
    delete: async function (url) {
        return _json(url, {}, 'POST')
    },
    batchDelete: async function (url, json) {
        return _json(url, json, 'POST')
    },
    isError: function (res) {
        if (res && res.status === 0) {
            return true
        }
        return false
    }
}

export function _encodeParam(param) {
    const obj = {...param, companyId}
    return Object.keys(obj)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key] ? obj[key] : '')}`)
        .join('&')
}

/**
 * 查询参数search形式.（search.xxx）
 * @param searchFields
 * @returns {string}
 * @private
 */
export function _encodeParamToSearch(searchFields ={}) {
    // 构建查询参数
    let search = {}
    Object.keys(searchFields).forEach(key => {
        if (searchFields[key]) {
            search[`search.${key}`] = searchFields[key].value ? searchFields[key].value : ((searchFields[key] + '') ? (searchFields[key] + '') : '')
        }
    })
    const obj = {...search, companyId}
    return Object.keys(obj)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key] ? obj[key] : '')}`)
        .join('&')
}

//url判断是否有？
const judgeURL = (url, param) =>{
    if(url.indexOf("?") === -1){
        url = `${url}?${_encodeParam(param)}`
    }else {
        url =  `${url}&${_encodeParam(param)}`
    }
    return url;
}


// WEBPACK FOOTER //
// ./src/utils/ajax.js